import React from 'react';

import { ReactComponent as FileCheckIcon } from '../../../../../../assets/icons/file-check-icon.svg';
import { ReactComponent as PromotionsIcon } from '../../../../../../assets/icons/percentage-icon.svg';
import { ReactComponent as HistoryIcon } from '../../../../../../assets/icons/file-heart-icon.svg';

import Chat from '../../ChatModal';
import LeadDetails from './components/LeadDetails';
import CoachDetails from './components/CoachDetails';
import Promotions from './components/Promotions';
import History from './components/History';
import Contract from './components/LeadModalContract';
import leadModalTabs from './tabs';
import texts from './texts';
import {
  StyledBadge,
  TabLabel,
  StyledUserIcon,
  StyledContractIcon,
  StyledChatIcon,
} from './styles';

const getLeadModalTabsConfig = (isISView, showActivePromotionBadge) => ({
  [leadModalTabs.LEAD_DETAILS]: {
    label: texts.tabLabels[leadModalTabs.LEAD_DETAILS],
    icon: FileCheckIcon,
    component: LeadDetails,
  },
  [leadModalTabs.CONTRACT]: {
    label: texts.tabLabels[leadModalTabs.CONTRACT],
    icon: StyledContractIcon,
    component: Contract,
  },
  ...(isISView ? {
    [leadModalTabs.COACH_DETAILS]: {
      label: texts.tabLabels[leadModalTabs.COACH_DETAILS],
      icon: StyledUserIcon,
      component: CoachDetails,
    },
    [leadModalTabs.PROMOTIONS]: {
      label: showActivePromotionBadge ? (
        <StyledBadge variant="dot">
          <TabLabel>{texts.tabLabels[leadModalTabs.PROMOTIONS]}</TabLabel>
        </StyledBadge>
      ) : (
        texts.tabLabels[leadModalTabs.PROMOTIONS]
      ),
      component: Promotions,
      icon: PromotionsIcon,
    },
  } : {}
  ),
  ...(isISView ? {
    [leadModalTabs.CHAT]: {
      label: texts.tabLabels[leadModalTabs.CHAT],
      icon: StyledChatIcon,
      component: Chat,
    },
  } : {}),
  [leadModalTabs.HISTORY]: {
    label: texts.tabLabels[leadModalTabs.HISTORY],
    icon: HistoryIcon,
    component: History,
  },
});

export {
  leadModalTabs,
  getLeadModalTabsConfig,
};
